module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/object/define-properties.js
// module id = HSQo
// module chunks = 0 28 29 32 33 34 39 45 46 108 109 110 111 112 113 114 116 117 123 124 125